import { GroupDivision } from '../shared/enums/GroupDivision';
import { StatusKenoby } from '../shared/enums/StatusKenoby';
import * as _ from 'lodash';
export class KenobyConsultant {
    _id: string;
    name: string;
    email: string;
    phone: string;
    city: string;
    state: string;
    gender: number;
    born: string;
    division: GroupDivision;
    status: StatusKenoby;
    skills: any[];
    position: string;
    opportunity: string;

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    loadConsultantFromServer(k: any) {
        this._id = k._id;
        this.name = k.name;
        this.email = k.email;
        this.phone = k.phone;
        this.city = k.city;
        this.state = k.state;
        this.gender = k.gender;
        this.born = k.born;
        this.status = k.status;
        this.division = k.division;
        this.skills = k.skills;
        this.position = k.position;
        this.opportunity = k.opportunity;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/KenobyConsultant.model.ts